import { makeVectorLayer,getStyle } from '../layers/index';
import { geojsonFormat, getSelectedMunicipality } from './tooltip';

const clusterLayer = makeVectorLayer({
    id: 'sampling-cluster-layer',
    type: 'Vector',
    visible: true,
    zIndex: 2,
    vector_params: {
        url: null,
        style: feature => getStyle({
            geom: 'Polygon',
            fill:{ color:'rgba(225,225,0,0.1)' },
            stroke: {color: '#fecd40', width:2},
            text: {text: `${feature.get('psu_id')}`},
        }),
    },
});

export const getSelectedSDDMM = () =>
{
    const municipality = getSelectedMunicipality();
    if (municipality){
        return municipality.get('SDDMM');
    }
    return null;
};

export const replaceClusterFeatures = geojson =>
{
    clusterLayer.getSource().clear();
    clusterLayer.getSource().addFeatures( geojsonFormat.readFeatures( JSON.stringify(geojson) ) );
};

export const handleToolModeSelection = (isSelected) =>
{
    clusterLayer.setVisible(isSelected);
};

export const setupSstTool = (map) =>
{
    map.addLayer(clusterLayer);
};
